<footer class="pt-lg-10 pt-5 footer bg-white">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <!-- about company -->
        <div class="mb-4">
          <img src="../../../assets/images/DumyUser/touch.png" alt="" class="img-fluid" style="height: 200px;">
          <div class="mt-4">
            <p>
              {{'EXPERT_SUPPORT' | translate}}
            </p>
            <!-- social media -->
            <div class="fs-4 mt-4">
              <a href="#" class="mdi mdi-facebook fs-4 text-muted me-2"></a>
              <a href="#" class="mdi mdi-twitter text-muted me-2"></a>
              <a href="#" class="mdi mdi-instagram text-muted "></a>
            </div>
          </div>
        </div>
      </div>
      <div class="offset-lg-1 col-lg-2 col-md-3 col-6">
        <div class="mb-4">
          <!-- list -->
          <h3 class="fw-bold mb-3">
            {{"REACH_US" | translate}}
          </h3>
          <ul class="list-unstyled nav nav-footer flex-column nav-x-0">
            <li><a routerLink="/contact" class="nav-link">Contact</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-6">
        <div class="mb-4">
          <!-- list -->
          <h3 class="fw-bold mb-3">
            {{"COMPANY" | translate}}
          </h3>
          <ul class="list-unstyled nav nav-footer flex-column nav-x-0">
            <li *ngFor="let post of sessionDataArray">
              <a [routerLink]="['/CompanyPage',post.id]" class="nav-link">
                {{post.title}}
              </a>
            </li>

          </ul>

        </div>
      </div>
      <div class="col-lg-3 col-md-12">
        <!-- contact info -->
        <div class="mb-4">
          <h3 class="fw-bold mb-3">
            {{"GET_IN_TOUCH" | translate}}
          </h3>
          <p>339 McDermott Points Hettingerhaven, NV 15283</p>
          <p class="mb-1">Email: <a href="#">supportmtyiazsui.com</a></p>
          <p>Phone: <span class="text-dark fw-semibold">(000) 123 456 789</span></p>

        </div>
      </div>
    </div>
    <div class="row align-items-center g-0 border-top py-2 mt-6">
      <!-- Desc -->
      <div class="col-lg-4 col-md-5 col-12">
        <span>© <span id="copyright2">
            <script>document.getElementById('copyright2').appendChild(document.createTextNode(new Date().getFullYear()))</script>
          </span>
          {{'TOUCHCONNECT_RIGHTS' | translate}} 
        </span>
      </div>

      <!-- Links -->
      <div class="col-12 col-md-7 col-lg-8 d-md-flex justify-content-end">

      </div>
    </div>
  </div>
</footer>
